import classNames from 'classnames'
import { Card } from '../card'
import { RadioButton } from '../controls'
import styles from './SelectableCard.module.scss'
import type { SelectableCardProps } from './types'
import { SelectableCardDisposition } from './types'
import { SelectableCardState } from '.'

const SelectableCard = ({
  className,
  state = SelectableCardState.unselected,
  disposition = SelectableCardDisposition.horizontal,
  children,
  disabled,
  showActionIndicator = true,
}: SelectableCardProps) => {
  return (
    <Card
      className={classNames(styles['pintxo-selectable-card'], className)}
      data-disabled={disabled}
      data-state={state}
    >
      <div
        className={classNames(styles['pintxo-selectable-card__container'])}
        data-disposition={disposition}
      >
        <RadioButton
          disabled={disabled}
          checked={state === SelectableCardState.selected}
          className={classNames(
            styles['pintxo-selectable-card__container__radio-button'],
            !showActionIndicator &&
              styles['pintxo-selectable-card__container__radio-button--hidden']
          )}
        />
        <div className={styles['pintxo-selectable-card__container__content']}>{children}</div>
      </div>
    </Card>
  )
}

export default SelectableCard
